import { createSlice } from '@reduxjs/toolkit'
import { ContextualState } from '../types/contextualFiltering.types'
const initialState: ContextualState = {
  contextualObject: null,
}

const contextualSlice = createSlice({
  name: 'contextualValue',
  initialState: initialState,
  reducers: {
    setContextualObject: (state: ContextualState, action) => {
      if (!state.contextualObject) {
        state.contextualObject = {}
      }
      const { key, value } = action.payload
      if (key) {
        state.contextualObject[key] = value
      }
    },
  },
})

export const { setContextualObject } = contextualSlice.actions
export default contextualSlice.reducer
